import { useLocation } from 'react-router-dom';
import { Lock } from 'lucide-react';

const MODULE_INFO = {
  '/operate': {
    name: 'Operate',
    tagline: 'Run the building like a machine.',
    description: 'Day-to-day facility operations, work orders, and maintenance workflows in one place.',
  },
  '/space': {
    name: 'Space',
    tagline: 'Spatial intelligence for every square foot.',
    description: 'Map, measure, and manage facility spaces with AI-driven floor plan analysis.',
  },
  '/recover': {
    name: 'Recover',
    tagline: 'Turn missed revenue into found money.',
    description: 'Automated cost recovery, warranty claim tracking, and reimbursement workflows.',
  },
  '/predict': {
    name: 'Predict',
    tagline: 'See what\'s coming before it arrives.',
    description: 'Predictive analytics for maintenance cycles, budget forecasting, and risk assessment.',
  },
  '/assess': {
    name: 'Assess',
    tagline: 'Know the true condition of every asset.',
    description: 'Facility condition assessments, scoring models, and capital planning intelligence.',
  },
};

export default function ComingSoonPage() {
  const { pathname } = useLocation();
  const info = MODULE_INFO[pathname] || { name: 'Module', tagline: 'Something exciting is on the way.', description: '' };

  return (
    <div className="flex items-center justify-center h-[calc(100vh-56px)]" data-testid="coming-soon-page">
      <div className="text-center max-w-md px-6">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 border border-primary/20 mb-6">
          <Lock className="w-7 h-7 text-primary" />
        </div>
        <h1 className="text-2xl font-heading font-bold uppercase tracking-wider text-foreground mb-2" data-testid="coming-soon-title">
          {info.name}
        </h1>
        <p className="text-sm text-muted-foreground font-medium mb-4">{info.tagline}</p>
        <p className="text-xs text-muted-foreground leading-relaxed mb-6">{info.description}</p>
        <span className="inline-block text-[10px] font-heading uppercase tracking-widest text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-950/30 border border-amber-300 dark:border-amber-800/40 px-3 py-1.5 rounded-sm">
          Coming Soon
        </span>
      </div>
    </div>
  );
}
